
<template>
<section>
  <div>
    <div class="columns">
      <div class="col">
        <chc-input v-model="data.note" :error="errors.note" label="Note" :required="true" v-on:enter="submit"></chc-input>
        <div class="field left">
          <input type="submit" class="btn" value="Save Note" @click="submit">
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'

export default {
  name: 'VehicleAddNote',
  data () {
    return {
      data: {
        note: ''
      },
      errors: {}
    }
  },
  props: ['vehicleId'],
  methods: {
    submit () {
      store.functions.vehicles.addNote(this.vehicleId, {
        note: this.data.note
      }, (errors) => {
        this.errors = errors
      }).then(() => {
        this.$emit('refresh')
        this.$emit('close')
      })
    }
  },
  computed: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Vehicle/VehicleAddNote.vue